export default function appState(state = {}, action) {
    switch (action.type) {
        case "SET_PAYLOAD":
            return Object.assign({}, state, {
                updated: new Date().getTime()
            }, action.payload || {});
        case "SET_APPLICATIONS":
            return Object.assign({}, state, {
                updated: new Date().getTime()
            }, action.applications || {});
        case "SET_SELECTED_APPLICATION":
            return Object.assign({}, state, {
                updated: new Date().getTime()
            }, { selectedApplication : action});
        default:
            return state;
    }
}
